export enum ConfirmationStep {
  Protection = 'protection',
  PersonalInfo = 'personalInfo',
  Address = 'address',
  Disclosures = 'disclosures',
  AnswerValidation = 'answerValidation',
  IdDocument = 'idDocument',
  ESignature = 'eSignature',
  Payment = 'payment',
}

export type ConfirmationStepsObject = {
  [K in ConfirmationStep]?: Date;
};
